import { useDispatch } from "react-redux";
import { Modal } from "@/components/modal/modal";

import { closeModal } from "libs/modals";
import { Button, FormSize } from "ui/ecosystems/forms";

import { INVITATION_USER_MODAL } from "../../UserModals";

export const InvitationUserModal = (props: {
  userName: string;
}): JSX.Element => {
  const dispatch = useDispatch();

  function closeInvitationModal() {
    dispatch(closeModal({ type: INVITATION_USER_MODAL }));
  }

  return (
    <div>
      <Modal
        show
        onHide={closeInvitationModal}
        animation={true}
        bsStyle="giselle"
        // @ts-ignore
        bsSize="md-reasonable"
      >
        <div className="p-6">
          <h4 className="m-0 text-2xl font-black leading-[29px] text-black">
            Invitation has been sent!
          </h4>
          <div className="mt-[17px]">
            <p className="text-base leading-[19px] text-black">
              {props.userName} will receive an invite link. Their permissions
              are already set — they&rsquo;ll be ready to use Sked as soon as
              they accept.
            </p>
          </div>
          <div className="mt-[38px] flex justify-end">
            <Button
              type="button"
              primary
              size={FormSize.large}
              onClick={closeInvitationModal}
              className="rounded-[10px] px-10"
            >
              Done
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
